import { render, staticRenderFns } from "./TicketingForItem.vue?vue&type=template&id=5d19bfcc&"
import script from "./TicketingForItem.vue?vue&type=script&lang=js&"
export * from "./TicketingForItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports